import { createSelector } from 'reselect'

import { fromToCitiesSelector, routeCitiesSelector } from './CitySelectors'

const getState = state => state.price
const getProps = (_, props) => props
const pricesSelector = state => getState(state).prices
const citiesRoutePriceSelector = state => getState(state).citiesRoutePrice
const fromToCitiesSaga = (_, fromToCities) => fromToCities

const citiesPriceSagaSelector = createSelector(
  pricesSelector,
  fromToCitiesSaga,
  (prices, { from, to }) => {
    const price = prices.find(({ id }) => id === `${from}_${to}`)

    return price
      ? price.price
      : ''
  }
)

const citiesPriceSelector = createSelector(
  pricesSelector,
  fromToCitiesSelector,
  (prices, fromToCities) => prices.find(({ id }) => id === fromToCities)
)

const pricesObj = createSelector(
  pricesSelector,
  prices => prices.reduce((acc, price) => {
    acc[price.id] = {
      price: price.price,
      returned: price.returned
    }

    return acc
  }, {})
)

/**
 * @return Price
 */

const connectionPricesSagaSelector = createSelector(
  pricesObj,
  getProps,
  (prices, { from, to }) => {
    const priceId = `${from}_${to}`
    const priceObj = prices[priceId]

    return priceObj ? priceObj.price : ''
  }
)

const connectionPricesSelector = createSelector(
  pricesObj,
  routeCitiesSelector,
  (prices, routeCities) => (
    routeCities.map(city => {
      const data = [
        { id: city.label }
      ]

      routeCities.forEach(({ id }) => {
        const priceId = `${city.id}_${id}`
        const priceObj = prices[priceId]
        const price = priceObj && priceObj.price
        const returned = priceObj && priceObj.returned

        const obj = {
          id: priceId,
          price: price || '-',
          returned
        }

        data.push(obj)
      })

      return data
    })
  )
)

export {
  pricesSelector,
  citiesPriceSagaSelector,
  citiesPriceSelector,
  citiesRoutePriceSelector,
  connectionPricesSelector,
  connectionPricesSagaSelector
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/PriceSelectors.js